import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { LogOut } from "lucide-react";
import { showToast } from "../../../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hitLogoutClientApi } from "../../../../../Redux/Client/LogoutClientSlice";

const Logout = ({ onCancel }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCancel = () => {
    if (typeof onCancel === "function") {
      onCancel();
    }
  };

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  const handleSignOut = () => {
    dispatch(hitLogoutClientApi()).then((response) => {
      if (response.payload && response.payload.status === true) {
        showToast("Logged out successfully", "success");
        localStorage.removeItem("clientToken");
        localStorage.removeItem("clientData");
        localStorage.removeItem("clientId");
        window.dispatchEvent(new Event("logout"));
        navigate("/client/login");
        window.location.reload();
      } else {
        showToast("Logout failed", "error");
      }
    });
  };

  return createPortal(
    <div
      className="logout-dialog-overlay"
      onClick={handleCancel}
      role="dialog"
      aria-modal="true"
      aria-labelledby="logout-dialog-title"
    >
      <div
        className="logout-page"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="dialog-container">
          <div className="icon-container">
            <LogOut className="logout-icon" size={32} strokeWidth={2.5} />
          </div>

          <h2 id="logout-dialog-title" className="dialog-title">
            Ready to sign out?
          </h2>
          <p className="dialog-description">
            You&apos;ll need to log back in to continue our services
          </p>

          <div className="dialog-actions">
            <button type="button" className="cancel-button" onClick={handleCancel}>
              Cancel
            </button>
            <button type="button" className="signout-button" onClick={handleSignOut}>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Logout;
